import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DiscountForm from '@/components/content/DiscountForm.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Discount } from '@/models/discounts.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentDiscounts',
  setup(__props) {

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();
const events = useEvents();

const discounts = computed<Discount[]>(() => store.state.cns.discounts);

const update = () => {
  store.dispatch(ContentStoreActions.GetDiscounts);
};

onMounted(() => {
  events.on(Event.UpdateContentItem, update);
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.UpdateContentItem, update);
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Initiative', key: 'initiative', width: '25%' },
  { title: 'Title', key: 'title', width: '30%' },
  { title: 'Used / Total Codes', key: 'codes', width: '20%' },
];

const editItem = (_: MouseEvent, rowData: { item: Discount }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(DiscountForm),
    data: rowData.item,
  });
};

const addItem = () => {
  const item: Discount = {
    id: -1,
    title: '',
    description: '',
    emailText: '',
    codes: [],
    initiative: null,
  };

  store.commit(Mutations.ShowDrawer, {
    component: markRaw(DiscountForm),
    data: item,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[1] || (_cache[1] = _createTextVNode("Discounts for Initiatives ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: discounts.value,
        "onClick:row": _withModifiers(editItem, ["prevent"]),
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.initiative": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.initiative?.title), 1)
        ]),
        "item.codes": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.codes.filter((c) => c.used).length) + " / " + _toDisplayString(item.codes.length), 1)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        color: "success",
        onClick: _cache[0] || (_cache[0] = () => addItem())
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Add Discount")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})